import unpin from '../../../../assets/img/svg/colum-order/unpin.svg';
import pin from '../../../../assets/img/svg/colum-order/pin.svg';
import { Opacity } from '../../../../enum/Opacity';
import { useColumnDragDrop } from '../../../../hook/useColumnDragDrop';
import { Column } from '../../../../enum/Column';
import { useAppDispatch } from '../../../../hook/useAppDispatch';
import { togglePin, toggleVisible } from '../../../../store/slice/column-slice';

interface ColumnOrderRowOptionsProps {
  column: Column;
  index: number;
}

const ColumnOrderRowOptions: React.FC<ColumnOrderRowOptionsProps> = ({ column, index }) => {
  const { ref, isDragging } = useColumnDragDrop({
    column,
  });
  const dispatch = useAppDispatch();

  return (
    <div
      ref={ref}
      key={column.name}
      className={`options_list ${isDragging ? 'dragging' : ''}`}
      style={{
        opacity: isDragging ? Opacity.DRAGGING : Opacity.DEFAULT,
        touchAction: 'manipulation',
      }}
    >
      <img src={column.isPinned ? pin : unpin} alt={'Pinned'} onClick={() => dispatch(togglePin(column.name))} />

      <div key={index} className="option_checkbox" onClick={() => dispatch(toggleVisible(column.name))}>
        <input type="checkbox" checked={column.isVisible ?? false} readOnly />
        <div className="option">
          <span>{column.name}</span>
        </div>
      </div>
      <div
        className="drag_drop_lines"
        style={{
          opacity: isDragging ? Opacity.DRAGGING : Opacity.DEFAULT,
          cursor: 'move',
        }}
      >
        <hr />
        <hr />
      </div>
    </div>
  );
};

export default ColumnOrderRowOptions;
